import { Injectable } from '@angular/core';
import * as L from 'leaflet';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  public map: any;
  constructor() { }

  public initMap(): void {
    this.map = L.map('map', {
      fullscreenControl: true,
      fullscreenControlOptions: {
        position: 'topleft'
      },
      center: [39.952333, -75.163916],
      zoom: 10
    });

    const tiles = L.tileLayer('https://tiles.septa.org/tiles/raster/{z}/{x}/{y}.png',
      {
        maxZoom: 17,
        minZoom: 9,
        attribution:
        '&copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/about/">OpenStreetMap contributors</a>'
      }
    );

    tiles.addTo(this.map);
  }
}
